@if (count) {
  @if (count > 0) {
    <span
      class="op-tab-count"
      [textContent]="count"
    ></span>
  }
}
